import { useTranslation } from 'react-i18next';

interface EmptyMenuItemsProps {
  message?: string;
}

export function EmptyMenuItems({ message }: EmptyMenuItemsProps) {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center justify-center rounded-lg border border-dashed p-8 text-center'>
      <h3 className='mt-2 text-lg font-semibold'>
        {t('emptyMenuItems.noItemsTitle')}
      </h3>
      <p className='mb-4 mt-1 text-sm text-muted-foreground'>
        {message || t('emptyMenuItems.defaultMessage')}
      </p>
    </div>
  );
}
